import { isExpired, decodeToken } from 'react-jwt';

/**
 * @description 로그인 후 기본 채널을 설정한다.
 * https://www.npmjs.com/package/secure-web-storage
 * @returns
 */
function useToken() {

  const validUser = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
      const t = !isExpired(accessToken);
      const userInfo = decodeToken(accessToken) as any;
      if (t && userInfo) {
        return true;
      } else {
        return false;
      }
    } else {
      // setIsValid(false);
      return false;
    }
  };

  return { validUser };
}

export default useToken;
